<template>
    <div class="mx-auto">

        <Modal v-if="showModal" :heightContainer="'auto'" :widthContainer="'40%'">
          <template v-slot:header>
            <h3 class="text-2xl" style="font-weight:700;text-align:center;">La videograbación ha terminado</h3>
            <h4 class="text-xl" style="font-weight:300;text-align:center;">Si ha cometido algún error al repetir el texto le recomendamos que vuelva a grabar el video.</h4>
            <h4 class="text-xl" style="font-weight:500;text-align:center;">¿Desea grabar de nuevo el video?</h4>
          </template>
          <template v-slot:body>
            <div>
              <div style="display:flex;justify-content:center;">
                <input type="button" value="Si" class="buttonWithoutBackground" @click="startRecording()">
                <input type="button" value="No. Continuar" class="buttonSave" @click="uploadVideo()" style="margin-left:10px;">
              </div>
            </div>
          </template>
        </Modal>

        <Modal v-if="showInstructions" :heightContainer="'auto'" :widthContainer="'40%'">
          <template v-slot:header>
            <h3 class="text-2xl" style="font-weight:700;text-align:center;">Instrucciones</h3>
            <h4 class="text-xl" style="font-weight:300;text-align:center;">Deberá leer detenidamente y en voz alta el texto que aparecerá después que dé click al botón <span style="font-weight:bold;">"Comenzar videograbación"</span>. Si ha terminado de leer todo el texto y el video aún no se detiene, puede dar click en el botón <span style="font-weight:bold;">"Detener videograbación"</span> para terminar con el video.</h4>
          </template>
          <template v-slot:body>
            <div>
              <div style="display:flex;justify-content:center;">
                <input type="button" value="Comenzar videograbación" class="buttonSave" @click="startRecording()">
                <input type="button" value="Cancelar" class="buttonWithoutBackground" @click="showInstructions = false" style="margin-left:10px;">
              </div>
            </div>
          </template>
        </Modal>
        
        <ModalTransparent v-show="showModalTransparent">
          <template v-slot:header>
            <div style="margin-top:0px;text-align:center;">
              <div style="display:flex;justify-content:center;margin-top:50px;">
                <div style="text-align:center;">
                  <button v-if="recording" class="Rec buttonRecording">Recording</button>
                </div>
                <div>
                  <input type="button" id="Button_StopVideo" v-if="recording" value="Detener videograbación" class="buttonStopVideo" @click="stopRecording()">
                </div>
              </div>
            </div>
          </template>
          <template v-slot:body>
            <div>
              <div class="marca" style="color:#000;">
                <section class="intro texto_intro" style="text-align:center;">
                </section>
                <section class="parrafos">
                  <div class="historia texto_historia">
                    <p>
                      {{text}}
                    </p>
                  </div>
                </section>
              </div>
            </div>
          </template>
          <template v-slot:footer>
            <div>
            </div>
          </template>
        </ModalTransparent>

        <div style="justify-content:center;padding:20px;text-align: center;">
            <div v-if="showDescription" style="">
              <p class="title" :class="view_class_view.title">
                Autenticación por videograbación
              </p>

              <div :class="view_class_view.div_content_sub_text">
                {{text_description}}
              </div>

              <div :class="view_class_view.div_content_sub_text">
                Favor de iniciar la grabación para dar por terminado el proceso de captura de sus datos.
              </div>

              <div style="display:flex;justify-content:center;margin-top:60px;" :class="view_class_view.div_content_button">
                <button class="btn-lg next_button" style="height:40px;width:240px; background-color:#fdce00" 
                  type="submit, text-decoration:none;border-color:#fdce00;background:#fdce00;" id="Button_ShowInstructionModal" v-on:click="showInstructionsModal()">
                    Iniciar Autenticación
                </button>
              </div>
            </div>

            <div v-show="recording">
              <label for="dispositivosDeAudio" hidden>Micrófono:</label><br>
              <select name="dispositivosDeAudio" id="dispositivosDeAudio" hidden></select>

              <br><br>

              <label for="dispositivosDeVideo" hidden>Cámara:</label><br>

              <select name="dispositivosDeVideo" id="dispositivosDeVideo" hidden></select>

              <br><br>

              <div style="display:flex;justify-content:center;position:relative;" class="">
                <div class="grid grid-cols-1">
                  <div>
                    <video muted="muted" id="video" style="width:100%;">
                    </video>
                  </div>
                </div>
              </div>

              <br><br><br>

              <div>
                <p class="duration">{{duration}}</p>
              </div>
              <!-- <video id="video2" width="200" height="200" controls /> -->
            </div>
        </div>
        
      </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import Video from '@/classes/VideoRecorder.js';
import Modal from './Forms/Modal.vue';
import ModalTransparent from './Forms/ModalTransparent.vue';
import Swal from "sweetalert2";

export default {
    name: 'VideoContractComponent',
    props: {
        view_class_view: {
            type: Object,
            dafault: {}
        },
        payment_frecuency: {
            type: String,
            default: ""
        },
        payment_method: {
            type: String,
            default: ""
        },
        bussines_name: {
            type: String,
            default: ""
        },
        text_video: {
            type: String,
            default: ""
        },
        text_description: {
            type: String,
            default: ""
        }
    },
    setup(props, {emit}) {
        let idInterval = ref("");
        let duration = ref(0);
        let videoClass = ref(null);
        let existMicrophone = ref(false);
        let existCamera = ref(false);
        let text = ref("");
        let recordingLength = ref(0);
        let showDescription = ref(true);
        let showModal = ref(false);
        let showModalTransparent = ref(false);
        let recording = ref(false);
        
        let showInstructions = ref(false);

        onMounted(async () => {
            await validateAcceptanceRecording();
            setControlsVideo();
            
            videoClass.value = new Video();
            
            if(props.text_video == "") {
                text.value = getProcessedScript(`Yo "Diga su nombre completo" deseo por voluntad propia formar parte de la cooperativa, por lo que  manifiesto que la información y documentación proporcionada es verídica, en caso de existir falsedad en ella, tengo pleno conocimiento de que mi solicitud será rechazada. De ser aceptada mi solicitud, autorizo para que realice un descuento vía “Diga el tipo de descuento que eligió ya sea NÓMINA o DOMICILIACIÓN” con una frecuencia de pago “Diga la frecuencua elegida, ejemplo: QUINCENAL, MENSUAL”`);
            }else{
                text.value = getProcessedScript(props.text_video);
            }

            recordingLength.value = videoClass.value.getRecordingLength;

            if (typeof MediaRecorder === "undefined" || !webBrowserSupportsUserMedia()) {
                Swal.fire({
                    title: "Aviso",
                    text: "Es necesario cambiar a navegador Chrome o Safari para poder continuar con el proceso.",
                    icon: "warning",
                    confirmButtonColor: '#FEB72B',
                }).then(function() {
                });
            }

            getDevices().then((devices)=> {
                validateDevices(devices);
            });
        });

        function getProcessedScript(script) {
            let wordsToBeReplaced = [
                { value: '"Diga su nombre completo"', newValue: "FREDY GUTIERREZ" },
                { value: '“Diga el tipo de descuento que eligió ya sea NÓMINA o DOMICILIACIÓN”', newValue: "$100,000.00" },
                { value: '“Diga la frecuencua elegida, ejemplo: QUINCENAL, MENSUAL”', newValue: "$100.00" }
            ];

            return videoClass.value.getProcessedScript(wordsToBeReplaced, script);
        }

        function setControlsVideo() {
            var w = window.innerWidth;
            var h = window.innerHeight;

            var intro = document.getElementsByClassName("intro")[0];
            var historia = document.getElementsByClassName("historia")[0];
            var parrafos = document.getElementsByClassName("parrafos")[0];
            // console.log("ancho de pantalla",);

            intro.style.fontSize = w / 30 + "px";
            if (w <= 1024) {
                historia.style.fontSize = w / 11 + "px";
            } else {
                historia.style.fontSize = w / 20 + "px";
            }
            parrafos.style.height = h + "px";

            // eslint-disable-next-line no-undef
            $('#recButton').addClass("notRec");

            // eslint-disable-next-line no-undef
            $('#recButton').click(function(){
                // eslint-disable-next-line no-undef
                if($('#recButton').hasClass('notRec')){
                    // eslint-disable-next-line no-undef
                    $('#recButton').removeClass("notRec");
                    // eslint-disable-next-line no-undef
                    $('#recButton').addClass("Rec");
                }
                else{
                    // eslint-disable-next-line no-undef
                    $('#recButton').removeClass("Rec");
                    // eslint-disable-next-line no-undef
                    $('#recButton').addClass("notRec");
                }
            });	
        }

        function animateScript() {
            var intro = document.getElementsByClassName("intro")[0];
            var historia = document.getElementsByClassName("historia")[0];
            intro.className = 'intro texto_intro animación_intro';
            historia.className = 'historia texto_historia animación_historia';
        }

        function quitAnimateScript() {
            var intro = document.getElementsByClassName("intro")[0];
            var historia = document.getElementsByClassName("historia")[0];
            intro.className = 'intro texto_intro';
            historia.className = 'historia texto_historia';
        }    

        function refresh() {
            let seconds = videoClass.value.getSecondsVideoRecording();
            if (seconds >= recordingLength.value) {
                stopRecording();
                return;
            }
            duration.value = videoClass.value.getRecordingTime(seconds);
        }

        function startRecording() {

            showModal.value = false;
            showInstructions.value = false
            if (!existMicrophone.value) {
                Swal.fire({
                    title: "Aviso",
                    text: "No se dectectó dispositivo de audio. Para continuar con el proceso favor de conectar un dispositivo de audio",
                    icon: "warning",
                    confirmButtonColor: '#FEB72B'
                });
                
                return;
            }

            if (!existCamera.value) {
                Swal.fire({
                    title: "Aviso",
                    text: "No se dectectó dispositivo de video. Para continuar con el proceso favor de conectar un dispositivo de video",
                    icon: "warning",
                    confirmButtonColor: '#FEB72B',
                });

                return;
            }

            videoClass.value.startRecording().then((isRecording) => {
                if (isRecording) {
                    showDescription.value = false;
                    showModalTransparent.value = true;
                    animateScript();
                    startCounting();
                    recording.value = true;
                    setScrollDown(); 
                } else {
                    Swal.fire({
                        title: "Aviso",
                        text: "Favor de dar permisos para que el el sitio web pueda hacer uso de su Cámara y Microfono.",
                        icon: "warning",
                        confirmButtonColor: '#FEB72B',
                    });
                }
            });
        }

        function setScrollDown(){
            // eslint-disable-next-line no-undef
            $('html, body').animate({scrollTop: $(document).height()}, 'slow');
        } 

        function uploadVideo() {
            showModal.value = false;
            Swal.fire({
                title: "Aviso",
                text: "La videograbación ha sido completada exitosamente",
                confirmButtonColor: '#FEB72B',
                confirmButtonText: "Continuar",
                allowOutsideClick: false,
                icon: "success",
            })
            emit("video-contract", videoClass.value);
        }

        function stopRecording() {
            videoClass.value.stopRecording();
            showModalTransparent.value = false;
            quitAnimateScript();
            stopCounting();
            showModal.value = true;
            recording.value = false;
        }

        function startCounting() {
            videoClass.value.setStartTime = Date.now();

            duration.value = "";
            setTimeRecordingInterval();
        }

        function setTimeRecordingInterval(){
            idInterval.value = setInterval(refresh, 500);
        }

        function stopCounting() {
            clearInterval(idInterval.value);
        }

        function getDevices() {
            return navigator
                .mediaDevices
                .enumerateDevices()
                .then(devices => {
                    return devices
                }).catch(() => {

                    Swal.fire({
                        title: "Aviso",
                        text: "No se detectaron dispositivos de audio y video, favor de conectar los dispositivos",
                        icon: "warning",
                        confirmButtonColor: '#FEB72B',
                    });

                });
        }

        const validateDevices = (devices) => {
            if (devices.length > 0) {

                devices.forEach((dispositivo) => {
                    if (dispositivo.kind === "audioinput") {
                        existMicrophone.value = true;
                    } else if (dispositivo.kind === "videoinput") {
                        existCamera.value = true;
                    }
                });

                if (!existMicrophone.value) {
                    Swal.fire({
                        title: "Aviso",
                        text: "No se detectó dispositivo de audio. Favor de conectar un dispositivo de audio",
                        icon: "warning",
                        confirmButtonColor: '#FEB72B',
                    });
                }

                if (!existCamera.value) {
                    Swal.fire({
                        title: "Aviso",
                        text: "No se detectó dispositivo de video. Favor de conectar un dispositivo de video",
                        icon: "warning",
                        confirmButtonColor: '#FEB72B',
                    });
                }
            } else {
                Swal.fire({
                    title: "Aviso",
                    text: "No se detectaron dispositivos de audio y video. Favor de conectar los dispositivos",
                    icon: "warning",
                    confirmButtonColor: '#FEB72B',
                }) 
            }
        }

        const webBrowserSupportsUserMedia = () => {
            return !!(navigator.mediaDevices.getUserMedia);
        }

        const showInstructionsModal = () => {
            showInstructions.value = true;
        }

        const  validateAcceptanceRecording = async () => {
            var payment_frecuency = props.payment_frecuency;
            var payment_method = props.payment_method;
            var html = `<p style='font-size:14px'>Como paso final, en la grabación deberá manifestar su deseo por voluntad propio de formar parte del sistema financiero colaborativo ${ props.bussines_name },  indicando su autorización de descuento por ${ payment_method } y la frecuencia de pago ${ payment_frecuency }. Concluida la video grabación se dará por concluido el proceso de registro.<br><br>Agradecemos su tiempo.</p>`;

            Swal.fire({
                html: `<p style='font-size:14px'>Le informamos que por disposición oficial su voz e imagen deben ser grabadas. <br><br>¿Autoriza que ${ props.bussines_name } grave su voz e imagen?.</p>`,
                showDenyButton: true,
                showCancelButton: false,
                icon: 'info',
                confirmButtonText: `Autorizo`,
                denyButtonText: `No autorizo`,
                confirmButtonColor: '#FEB72B',
                denyButtonColor: '#FEB72B',
                reverseButtons: true
            }).then((result) => {

                if (result.isConfirmed) {

                    Swal.fire({
                        title: "Aviso",
                        html: html,
                        icon: "warning",
                        confirmButtonColor: '#FEB72B',
                    });

                } else if (result.isDenied) {

                    Swal.fire({
                        html: `<p style='font-size:14px'>Para continuar con el trámite es necesario nos autorice grave su voz e imagen <br><br>¿Autoriza que ${ props.bussines_name } grave su voz e imagen?.</p>`,
                        showDenyButton: true,
                        showCancelButton: false,
                        icon: 'info',
                        confirmButtonText: `Autorizo`,
                        denyButtonText: `No autorizo`,
                        confirmButtonColor: '#FEB72B',
                        denyButtonColor: '#FEB72B',
                    }).then((result) => {
                        if (result.isConfirmed) {
                            Swal.fire({
                                title: "Aviso",
                                html: html,
                                icon: "warning",
                                confirmButtonColor: '#FEB72B'
                            });
                        } else if (result.isDenied) {
                            emit("video-contract", null);
                        }
                    });

                }
            });
        }

        
        return {
            startRecording,
            stopRecording,
            recording,
            duration,
            uploadVideo,
            showInstructionsModal,
            showModal,
            showInstructions,
            text,
            showModalTransparent,
            showDescription
        }
    },
    components:{
        Modal,
        ModalTransparent
    }
}

</script>

<style scoped>
    #video {
        border-radius:5px;
    }
    .button_popups {
        border-top-left-radius: 7px !important;
        border-top-right-radius: 7px !important;
        border-bottom-left-radius: 7px !important;
        border-bottom-right-radius: 7px !important;
        background-color: #feb72b !important;
        color: #fff !important;
        font-weight:bold !important;
        width: 250px !important;
        height: 40px !important;
        padding-top: 0% !important;
        font-size:16px !important;
    }
    @media (max-width: 500px) {
        .button_popups {
            height: 50px !important;
        }
    }

    .buttonSave {
        border-color: 1px solid #FFCC00;
        background-color: #FFCC00; /* Green */
        border: none;
        border-radius: 5px;
        color: white;
        padding: 1px 10px;
        text-align: center;
        text-decoration: none;
        display: inline-block;
        font-size: 14px;
        
        widows: 10px;
        height: 30px;
        cursor: pointer;
    }
    .buttonSave:hover {
        background-color: #FFDB4B;
    }

    .buttonWithoutBackground {
        background-color: #fff; /* Green */
        border: 1px solid #FFCC00;
        border-radius: 5px;
        color: #FFCC00;
        padding: 1px 10px;
        text-align: center;
        text-decoration: none;
        display: inline-block;
        font-size: 14px;
        
        widows: 10px;
        height: 30px;
        cursor: pointer;
    }

    .buttonStopVideo {
        background-color: red; /* Green */
        opacity: 1;
        border: none;
        border-radius: 5px;
        color: white;
        padding: 1px 10px;
        text-align: center;
        text-decoration: none;
        display: inline-block;
        font-size: 16px;
        widows: 10px;
        height: 30px;
        cursor: pointer;
    }


    .duration {
        font-size:15px;
    }
    .video { position: relative; overflow: hidden; }
    .marca { 
        position: relative;
        bottom: 0px;
        font-family: Arial;
        font-weight: bold;
        font-size: 18px;
        width: 100%;
        height: 100%;
        margin:0 auto;
        text-align: center;
        color: #000 !important;
        overflow: hidden;
        border-bottom-left-radius: 5px;
        border-bottom-left-radius: 5px;
    }

    .intro {
        position: absolute;
        top: 40%;
        left: 20%;
        z-index: 1;
        opacity: 0;
    }

    .texto_intro {
        font-family: "News Cycle", sans-serif;
        color: #4bd5ee;
        font-weight: 400;
        letter-spacing: .1em;
    }

    .historia {
        position: absolute;
        top: 100%;
    }

    /* .parrafos {
    position: absolute;
    left: 15%;
    width: 100%;
    z-index: 1;
    } */

    .texto_historia {
        padding:3%;
        font-family: "News Cycle", sans-serif;
        font-weight: 700;
        color: #fff;
        text-align: center;
        letter-spacing: .1em;
        line-height: 1.1em;
    }

    .animación_intro {
        animation: parrafos 50s linear 0s;
    }

    .animación_historia {
        animation: parrafos 230s ease-out 0s;
    }

    @keyframes intro {
        0% {
            opacity: 0;
        }
        20% {
            opacity: 1;
        }
        90% {
            opacity: 1;
        }
        100% {
            opacity: 0;
        }
    }

    @keyframes parrafos {
        0% {
            top: 70%;
            opacity: 1;
        }
        95% {
            opacity: 1;
        }
        100% {
            top: -1000%;
            opacity: 0;
        }
    }

    .buttonRecording {
        width: 30px;
        height: 30px;
        font-size: 0;
        background-color: red;
        border: 0;
        border-radius: 35px;
        margin-right: 18px;
        outline: none;
    }

    .notRec{
        background-color: darkred;
    }

    .Rec{
        animation-name: pulse;
        animation-duration: 1.5s;
        animation-iteration-count: infinite;
        animation-timing-function: linear;
    }

    @keyframes pulse{
        0%{
            box-shadow: 0px 0px 5px 0px rgba(173,0,0,.3);
        }
        65%{
            box-shadow: 0px 0px 5px 13px rgba(173,0,0,.3);
        }
        90%{
            box-shadow: 0px 0px 5px 13px rgba(173,0,0,0);
        }
    }

    @media screen and (max-width: 1024px) {
        .animación_historia {
            animation: parrafos 130s linear 0s !important;
        }
        @keyframes parrafos {
            0% {
                top: 85%;
                opacity: 1;
            }
            95% {
                opacity: 1;
            }
            100% {
                top: -1000%;
                opacity: 0;
            }
        }
    }

    @media screen and (max-width: 768px) {
        .animación_historia {
            animation: parrafos 175s linear 0s !important;
        }
    }

    @media screen and (max-width: 640px) {
        .animación_historia {
            animation: parrafos 165s linear 0s !important;
        }
    }

    @media screen and (max-width: 501px) {
        .animación_historia {
            animation: parrafos 165s linear 0s !important;
        }
    } 
</style>